const getters = {
  attr: state => state.index1.attr,
  status: state => state.index1.status,
  statusStr: state => state.index1.statusStr,
  refresh: state => state.index1.refresh,
  listchange: state => state.index1.listchange,
  symbolchange: state => state.index1.symbolchange,
  code: state => state.index1.code,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js